import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { McIconComponent } from './mc-icon/mc-icon.component';
import { BytesPipe, EmojisPipe, TogglePasswordPipe, OrderPipe, SafePipe } from '../_pipes';
import {
    PreventDefaultDirective,
    FocusOnInputDirective,
    TrimValueAccessorDirective,
    ClickOutsideDirective,
    AutoFocusDirective,
} from '../_directives';
import { McLoadingComponent } from './mc-loading/mc-loading.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { McToastComponent } from './mc-toast/mc-toast.component';
import { TranslateModule } from '@ngx-translate/core';
import { McFormGroupCheckComponent, McFormGroupInputComponent, McSelectCodCountryComponent } from './form-group';
import { NgxsModule } from '@ngxs/store';
import { FileUploadModule } from 'ng2-file-upload';
import { ProfileState } from '../pages/usuario/store/profile.state';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { McSectionContextualMenuComponent } from './';

import {
    InfoMarketFormComponent,
    SelectTemplateComponent,
    SelectVerticalComponent,
    SocialMediaComponent,
    WelcomeWizardComponent,
    LoadingAnimatedComponent,
    LoadingCreatingSiteComponent,
    CreateSiteAiComponent,
    PreviewSiteIaComponent,
} from './ss-stepper';

// SS custom components
import { SScheckboxComponent } from '@app/components/form-group/ss-checkbox/ss-checkbox.component.component';
import { SsChipComponent } from './ss-chip/ss-chip.component';
import { SsStepperComponent } from './ss-stepper/ss-stepper.component';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgModule } from '@angular/core';
import { FileUploadComponent } from './ss-file-upload/file-upload.component';
import { MarketSectionsComponent } from './ss-stepper/steps/market-sections/market-sections.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSelectCountryModule } from '@angular-material-extensions/select-country';
import { DesignState } from '@app/pages/web-site/design/store/design.state';
import { SettingsState } from '@app/pages/web-site/settings/store/settings.state';
import { BasicInfoState } from '@app/pages/web-site/basic-info/store/basic-info.state';
import { ContactDataState } from '@app/pages/web-site/contact-data/store/contact-data.state';
import { PageLanguagesState } from './../pages/web-site/settings/page-languages/store/page-languages.state';
import { IntegrationState } from '@app/pages/tools/integrations/store/integration.state';
import { DomainsState } from '@app/pages/domains/store/domains.state';
import { TrialExpiredComponent } from './trial-expired/trial-expired.component';
import { StatisticsState } from '@app/pages/statistics/website/store/statistics.state';
import { SsAlertComponent } from './ss-alert/ss-alert.component';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatPaginationIntlService } from '@app/_services/paginator.service';
import { PaginatorComponent } from '@app/components/paginator/paginator.component';
import { SsConfirmComponent } from './ss-confirm/ss-confirm.component';
import { SsButtonComponent } from './ss-button/ss-button.component';
import { CanExitModalComponent } from './can-exit-modal/can-exit-modal.component';
import { FileUploadWizardComponent } from './file-upload-wizard/file-upload-wizard.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CatalogState } from '@app/pages/e-commerce/catalog/store/catalog.state';
import { KeywordPillsComponent } from './keyword-pills/keyword-pills.component';
import { MatInputModule } from '@angular/material/input';
import { SsImageComponent } from './ss-image/ss-image.component';
import { HeaderCustomizationState } from '@app/pages/web-site/design/header-customization/store/header-customization.state';
import { VersionBarComponent } from './version';
import { SsFormGroupInputComponent } from './form-group/ss-form-group-input/ss-form-group-input.component';
import { LanguageSelectComponent } from './mc-language-select/mc-language-select.component';
import { UserAccessComponent } from '@app/pages/usuario/accesos';
import { McCropperComponent } from './image-cropper/cropper.component';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { AppState } from '@app/core/store/app.state';
import { ImgModalComponent } from './img-modal/img-modal.component';
import { ImagesState } from './img-modal/store/images.state';
import { UploadImagesComponent } from './img-modal/components/upload-images/upload-images.component';
import { InstagramUploadComponent } from './img-modal/components/instagram-upload/instagram-upload.component';
import { UrlUploadComponent } from './img-modal/components/url-upload/url-upload.component';
import { MatCardModule } from '@angular/material/card';
import { InstagramEmptyStateComponent } from './img-modal/components/instagram-empty-state/instagram-empty-state.component';
import { ImgFileUploadComponent } from './img-modal/components/file-upload/file-upload.component';
import { DragDropDirective } from '@app/_directives/img-drag-drop.directive';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UsedImagesModalComponent } from './img-modal/components/used-images-modal/used-images-modal.component';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
// import { CarouselModalComponent } from './img-modal/components/carousel-modal/carousel-modal.component';
import { ImagePreviewModalComponent } from './img-modal/components/image-preview-modal/image-preview-modal.component';
import { ImagesSliderComponent } from './img-modal/components/images-slider/images-slider.component';
import { CarouselModalComponent } from './img-modal/components/carousel-modal/carousel-modal.component';
import { LoadingSkeletonComponent } from './loading-skeleton/loading-skeleton.component';
import { PexelsUploadComponent } from './img-modal/components/pexels-upload/pexels-upload.component';
import { PexelsEmptyStateComponent } from './img-modal/components/pexels-empty-state/pexels-empty-state.component';
import { MatChipsModule } from '@angular/material/chips';
import { VoiceRecorderComponent } from './voice-recorder/voice-recorder.component';
import { EntityIaContentModalComponent } from './entity-ia-content-modal/entity-ia-content-modal.component';
import { EntityIaContentState } from './entity-ia-content-modal/store/entity-ia-content.store';
import { CustomizeThemeModalComponent } from './ss-stepper/steps/preview-site-ia/customize-theme-modal/customize-theme-modal.component';
import { WizardErrorModalComponent } from './ss-stepper/stepper-components/wizard-error-modal/wizard-error-modal.component';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { InternalNavComponent } from './internal-nav/internal-nav.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { SsAlertIAComponent } from './ss-alert-ia/ss-alert-ia.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RegenerateSiteDialogComponent } from './ss-stepper/stepper-components/regenerate-site-dialog/regenerate-site-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        NgxPaginationModule,
        BsDatepickerModule.forRoot(),
        NgxsModule.forFeature([
            ProfileState,
            DesignState,
            SettingsState,
            BasicInfoState,
            ContactDataState,
            PageLanguagesState,
            IntegrationState,
            DomainsState,
            StatisticsState,
            CatalogState,
            HeaderCustomizationState,
            AppState,
            ImagesState,
            EntityIaContentState,
        ]),
        FileUploadModule,
        RouterModule,
        CdkStepperModule,
        MatFormFieldModule,
        MatSelectModule,
        MatSelectCountryModule.forRoot('es'),
        TranslateModule,
        MatPaginatorModule,
        MatDialogModule,
        InfiniteScrollModule,
        MatChipsModule,
        MatInputModule,
        MatIconModule,
        MatToolbarModule,
        AngularCropperjsModule,
        MatCardModule,
        MatCheckboxModule,
        MatListModule,
        MatMenuModule,
        NgbCarouselModule,
        MatExpansionModule,
        MatProgressBarModule,
    ],
    declarations: [
        // PIPES
        BytesPipe,
        TogglePasswordPipe,
        EmojisPipe,
        OrderPipe,
        SafePipe,
        // DIRECTIVES
        PreventDefaultDirective,
        FocusOnInputDirective,
        AutoFocusDirective,
        TrimValueAccessorDirective,
        ClickOutsideDirective,
        DragDropDirective,
        // COMPONENTS
        McIconComponent,
        McLoadingComponent,
        McFormGroupInputComponent,
        SsFormGroupInputComponent,
        McFormGroupCheckComponent,
        McSelectCodCountryComponent,
        McToastComponent,
        McSectionContextualMenuComponent,
        SsChipComponent,
        SScheckboxComponent,
        SsStepperComponent,
        InfoMarketFormComponent,
        CreateSiteAiComponent,
        PreviewSiteIaComponent,
        CustomizeThemeModalComponent,
        SelectTemplateComponent,
        SelectVerticalComponent,
        SocialMediaComponent,
        FileUploadComponent,
        MarketSectionsComponent,
        LoadingAnimatedComponent,
        LoadingCreatingSiteComponent,
        WelcomeWizardComponent,
        WizardErrorModalComponent,
        TrialExpiredComponent,
        SsAlertComponent,
        SsAlertIAComponent,
        PaginatorComponent,
        SsConfirmComponent,
        SsButtonComponent,
        CanExitModalComponent,
        FileUploadWizardComponent,
        KeywordPillsComponent,
        SsImageComponent,
        VersionBarComponent,
        LanguageSelectComponent,
        UserAccessComponent,
        McCropperComponent,
        ImgModalComponent,
        UploadImagesComponent,
        InstagramUploadComponent,
        UrlUploadComponent,
        ImgFileUploadComponent,
        InstagramEmptyStateComponent,
        UsedImagesModalComponent,
        CarouselModalComponent,
        ImagePreviewModalComponent,
        ImagesSliderComponent,
        LoadingSkeletonComponent,
        PexelsUploadComponent,
        PexelsEmptyStateComponent,
        VoiceRecorderComponent,
        EntityIaContentModalComponent,
        InternalNavComponent,
        RegenerateSiteDialogComponent,
    ],
    exports: [
        // MODULES
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        BsDatepickerModule,
        NgxPaginationModule,
        CdkStepperModule,
        MatSelectCountryModule,
        InfiniteScrollModule,
        MatChipsModule,
        MatInputModule,
        AngularCropperjsModule,
        // PIPES
        BytesPipe,
        TogglePasswordPipe,
        OrderPipe,
        SafePipe,
        // DIRECTIVES
        PreventDefaultDirective,
        FocusOnInputDirective,
        AutoFocusDirective,
        DragDropDirective,
        // COMPONENTS
        McIconComponent,
        McLoadingComponent,
        McFormGroupInputComponent,
        SsFormGroupInputComponent,
        McFormGroupCheckComponent,
        McSelectCodCountryComponent,
        McToastComponent,
        EmojisPipe,
        McSectionContextualMenuComponent,
        TrimValueAccessorDirective,
        ClickOutsideDirective,
        SsChipComponent,
        SScheckboxComponent,
        SsStepperComponent,
        InfoMarketFormComponent,
        CreateSiteAiComponent,
        PreviewSiteIaComponent,
        CustomizeThemeModalComponent,
        SelectTemplateComponent,
        SelectVerticalComponent,
        SocialMediaComponent,
        MarketSectionsComponent,
        LoadingAnimatedComponent,
        LoadingCreatingSiteComponent,
        WelcomeWizardComponent,
        WizardErrorModalComponent,
        TrialExpiredComponent,
        FileUploadComponent,
        PaginatorComponent,
        SsButtonComponent,
        CanExitModalComponent,
        FileUploadWizardComponent,
        KeywordPillsComponent,
        SsImageComponent,
        VersionBarComponent,
        LanguageSelectComponent,
        UserAccessComponent,
        McCropperComponent,
        ImgModalComponent,
        UploadImagesComponent,
        InstagramUploadComponent,
        UrlUploadComponent,
        ImgFileUploadComponent,
        InstagramEmptyStateComponent,
        UsedImagesModalComponent,
        CarouselModalComponent,
        ImagePreviewModalComponent,
        ImagesSliderComponent,
        LoadingSkeletonComponent,
        PexelsUploadComponent,
        PexelsEmptyStateComponent,
        VoiceRecorderComponent,
        EntityIaContentModalComponent,
        InternalNavComponent,
        RegenerateSiteDialogComponent,
    ],
    providers: [
        BytesPipe,
        CurrencyPipe,
        {
            provide: MatPaginatorIntl,
            useClass: MatPaginationIntlService,
        },
    ],
})
export class McCommonModule {}
